/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ClearingHouse } from "./ClearingHouse";

export class ClearingHouseFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ClearingHouse> {
    return super.deploy(overrides || {}) as Promise<ClearingHouse>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ClearingHouse {
    return super.attach(address) as ClearingHouse;
  }
  connect(signer: Signer): ClearingHouseFactory {
    return super.connect(signer) as ClearingHouseFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ClearingHouse {
    return new Contract(address, _abi, signerOrProvider) as ClearingHouse;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidationFeeRatio",
        type: "uint256",
      },
    ],
    name: "LiquidationFeeRatioChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "amm",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "fundingPayment",
        type: "int256",
      },
    ],
    name: "MarginChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "marginRatio",
        type: "uint256",
      },
    ],
    name: "MarginRatioChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "amm",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "newPositionSize",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldLiquidityIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLiquidityIndex",
        type: "uint256",
      },
    ],
    name: "PositionAdjusted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "amm",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "margin",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionNotional",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "exchangedPositionSize",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "positionSizeAfter",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "realizedPnl",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "unrealizedPnlAfter",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "badDebt",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidationPenalty",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "spotPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "fundingPayment",
        type: "int256",
      },
    ],
    name: "PositionChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "amm",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionNotional",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionSize",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidationFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "liquidator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "badDebt",
        type: "uint256",
      },
    ],
    name: "PositionLiquidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "amm",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "valueTransferred",
        type: "uint256",
      },
    ],
    name: "PositionSettled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "amm",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "RestrictionModeEntered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_addedMargin",
        type: "tuple",
      },
    ],
    name: "addMargin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "adjustPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmountLimit",
        type: "tuple",
      },
    ],
    name: "closePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feePool",
    outputs: [
      {
        internalType: "contract IMultiTokenRewardRecipient",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "getLatestCumulativePremiumFraction",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "getMarginRatio",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "getPosition",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "size",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "margin",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "openNotional",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "lastUpdatedCumulativePremiumFraction",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "liquidityHistoryIndex",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct ClearingHouse.Position",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
      {
        internalType: "enum ClearingHouse.PnlCalcOption",
        name: "_pnlCalcOption",
        type: "uint8",
      },
    ],
    name: "getPositionNotionalAndUnrealizedPnl",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "positionNotional",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "unrealizedPnl",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "getUnadjustedPosition",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "size",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "margin",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "openNotional",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "lastUpdatedCumulativePremiumFraction",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "liquidityHistoryIndex",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct ClearingHouse.Position",
        name: "position",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initMarginRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_initMarginRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maintenanceMarginRatio",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_liquidationFeeRatio",
        type: "uint256",
      },
      {
        internalType: "contract IInsuranceFund",
        name: "_insuranceFund",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "insuranceFund",
    outputs: [
      {
        internalType: "contract IInsuranceFund",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "liquidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidationFeeRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maintenanceMarginRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "openInterestNotionalMap",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "enum ClearingHouse.Side",
        name: "_side",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_quoteAssetAmount",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_leverage",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_baseAssetAmountLimit",
        type: "tuple",
      },
    ],
    name: "openPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "payFunding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_removedMargin",
        type: "tuple",
      },
    ],
    name: "removeMargin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IMultiTokenRewardRecipient",
        name: "_feePool",
        type: "address",
      },
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_liquidationFeeRatio",
        type: "tuple",
      },
    ],
    name: "setLiquidationFeeRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_maintenanceMarginRatio",
        type: "tuple",
      },
    ],
    name: "setMaintenanceMarginRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_whitelist",
        type: "address",
      },
    ],
    name: "setWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "settlePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "trustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
